import { PartialType } from '../../../utils';
import { CreateBankCardDto } from './create-bank-card.dto';
export class UpdateBankCardDto extends PartialType(CreateBankCardDto) {
}
